// prettier-ignore
const ALL = [
  { id: 0,  name: 'rooster',           'pt-BR': 'Galo',            'en-US': 'Rooster' },
  { id: 1,  name: 'light_feather',     'pt-BR': 'Pluma',           'en-US': 'Light Feather' },
  { id: 2,  name: 'feather',           'pt-BR': 'Pena',            'en-US': 'Feather' },
  { id: 3,  name: 'light',             'pt-BR': 'Leve',            'en-US': 'Light' },
  { id: 4,  name: 'middle',            'pt-BR': 'Médio',           'en-US': 'Middle' },
  { id: 5,  name: 'medium_heavy',      'pt-BR': 'Medio Pesado',    'en-US': 'Medium Heavy' },
  { id: 6,  name: 'heavy',             'pt-BR': 'Pesado',          'en-US': 'Heavy' },
  { id: 7,  name: 'super_heavy',       'pt-BR': 'Super Pesado',    'en-US': 'Super Heavy' },
  { id: 8,  name: 'ultra_heavy',       'pt-BR': 'Pesadíssimo',     'en-US': 'Ultra Heavy' },
  { id: 9,  name: 'open_class',        'pt-BR': 'Absoluto',        'en-US': 'Open Class' },
  { id: 10, name: 'open_class_light',  'pt-BR': 'Absoluto Leve',   'en-US': 'Open Class Light' },
  { id: 11, name: 'open_class_heavy',  'pt-BR': 'Absoluto Pesado', 'en-US': 'Open Class Heavy' }
]

export function all() {
  return [...ALL]
}

// Os pesos de verdade sao NOVE — o enum do legado inteiro (Rooster=0 ... UltraHeavy=8). A lista
// acima tem doze porque os tres open_class* foram acrescentados para ter id, nome e traducao: nao
// sao divisoes de peso, e sim pseudo-divisoes que a geracao de categorias materializa para o
// absoluto. Espelha WeightDivision.real do core.
export function real() {
  return ALL.filter(division => !division.name.startsWith('open_class'))
}

export function findById(id) {
  return ALL.find(division => division.id === +id)
}

export function findByName(name) {
  return ALL.find(division => division.name === name)
}
